"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function NeedHelpSection() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  return <section id="need-help" ref={ref} className="relative bg-dark-background text-foreground-dark py-16 lg:py-20 overflow-hidden">
      {}
      <div className="absolute inset-0 flex items-center justify-center opacity-5 pointer-events-none">
        <svg className="w-96 h-96 lg:w-[32rem] lg:h-[32rem]" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="100" cy="100" r="80" stroke="currentColor" strokeWidth="2" fill="none" />
          <path d="M100 40 L100 100 L140 100" stroke="currentColor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
          <circle cx="100" cy="100" r="8" fill="currentColor" />
        </svg>
      </div>

      {}
      <div className="relative container mx-auto px-4 max-w-4xl text-center">
        <div className={`transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2"}`}>
          <h2 className="text-3xl lg:text-4xl font-display font-bold mb-4 tracking-tight">
            Need Help?
          </h2>
          <p className="text-lg lg:text-xl text-white/90 mb-8 max-w-2xl mx-auto leading-relaxed">
            Have questions about our ABA therapy services or ready to get started? We're here to support you and your family every step of the way.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button asChild size="lg" className="bg-primary text-foreground-primary hover:bg-primary-hover hover:scale-[1.02] active:scale-[0.98] shadow-soft hover:shadow-medium transition-all duration-[var(--duration-fast)] ease-[var(--ease-smooth)] px-8 py-3 rounded-[var(--radius-md)]">
              <Link to="/GetStartedPage">Request Services</Link>
            </Button>

            <Button asChild variant="outline" size="lg" className="bg-white/10 text-white border-white/30 hover:bg-white/20 hover:border-white/40 hover:scale-[1.02] active:scale-[0.98] shadow-soft hover:shadow-medium transition-all duration-[var(--duration-fast)] ease-[var(--ease-smooth)] px-8 py-3 rounded-[var(--radius-md)]">
              <Link to="tel:+13051234567">Call Us</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}